export const initChatContinuousOption = function (data, ping = false, area = false) {
  let option = {}
  option = {
    visualMap: [{
      show: false,
      type: 'continuous',
      seriesIndex: 0,
      min: 0,
      max: data.max | 2
    }],
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    legend: {
      data: data.legend
    },
    tooltip: {
      trigger: 'axis'
    },
    xAxis: [{
      data: data.xData
    }],
    yAxis: [{
      splitLine: {show: false}
    }],
    series: []
  }
  data.yData.forEach(function (item, index) {
    option.series.push({
      type: 'line',
      name: data.legend[index],
      step: ping ? 'start' : '',
      areaStyle: area ? {normal: {}} : {},
      showSymbol: false,
      data: item
    })
  })
  return option
}

export const initChatPreOptionBak = function (data) {
  let option = {}
  option = {
    title: {
      text: '成本',
      left: 'center',
      top: 20,
      textStyle: {
        color: '#ccc'
      }
    },
    tooltip: {
      trigger: 'item',
      formatter: '{a} <br/>{b} : {c} ({d}%)'
    },
    visualMap: {
      show: false,
      min: 0,
      max: 2000,
      inRange: {
        colorLightness: [0, 1]
      }
    },
    series: [{
      name: '成本',
      type: 'pie',
      radius: '55%',
      center: ['50%', '50%'],
      data: data.sort(function (a, b) { return a.value - b.value }),
      roseType: 'radius',
      label: {
        normal: {
          textStyle: {
            color: 'rgba(0, 0, 0, 0.3)'
          }
        }
      },
      labelLine: {
        normal: {
          lineStyle: {
            color: 'rgba(0,0, 0, 0.3)'
          },
          smooth: 0.2,
          length: 10,
          length2: 20
        }
      },
      itemStyle: {
        normal: {
          color: '#c23531',
          shadowBlur: 200,
          shadowColor: 'rgba(0, 0, 0, 0.5)'
        }
      },
      animationType: 'scale',
      animationEasing: 'elasticOut',
      animationDelay: function (idx) {
        return Math.random() * 1000
      }
    }
    ]
  }
  return option
}

export const initChatPreOption = function (data) {
  let option = {}
  option = {
    title: {
      text: '成本',
      left: 'center',
      top: 20,
      textStyle: {
        color: '#666'
      }
    },
    tooltip: {
      trigger: 'item',
      formatter: '{b} : {c} ({d}%)'
    },
    series: [{
      type: 'pie',
      radius: '55%',
      center: ['50%', '60%'],
      data: data,
      itemStyle: {
        emphasis: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: 'rgba(0, 0, 0, 0.5)'
        }
      }
    }]
  }
  return option
}



// WEBPACK FOOTER //
// ./src/eleChatOption.js